export const formatPriceDecimal = (value: number, minFractionalDigits?: number) => {
  const price = new Intl.NumberFormat('fi-FI', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: minFractionalDigits,
  }).format(value)

  return price
}
